import { Component, inject, Input, OnChanges, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HtmlUtilsService } from 'src/app/source/utils/html-utils.service';
import { Reactions } from '../reactions/interfaces/reactions.interface';

@Component({
  selector: 'app-news-small-card',
  templateUrl: './news-small-card.component.html',
  styleUrls: ['./news-small-card.component.scss', '../news-large-card/news-large-card.component.scss']
})
export class NewsSmallCardComponent implements OnChanges {
    private router: Router = inject(Router);
    private htmlUtils = inject(HtmlUtilsService);


  @Input() id: string = '';
  @Input() image: string = '';
  @Input() category: string = '';
  @Input() categoryBackgroundColor: string = '';
  @Input() categoryFontColor: string = '';
  @Input() title: string = '';
  @Input() date: string = '';
  @Input() content: string = '';
  @Input() readingTime: string = '';
  @Input() link: string = '';
  @Input() reactions: Reactions;


 public textContent: string = '';

  ngOnChanges(): void {
    const withoutImage = this.htmlUtils.removeLeadingImage(this.content);
    const div = document.createElement('div');
    div.innerHTML = withoutImage;
    this.textContent = div.textContent?.trim() || '';
  }

  navigateToDetails() {
    console.log(`pulsado noticia con id: ${this.id}`);
    this.router.navigate(['/noticia', this.id]);
  }
}
